export const APIDATE: string = "YYYY-MM-DD";
export const APIDATETIME: string = "YYYY-MM-DDTHH:mm:ss";

export const DATEFORMAT: string = "YYYY.MM.DD";
export const DATETIMEFORMAT: string = "YYYY.MM.DD HH:mm:ss";
export const DATETIMESHORT: string = "YYYY.MM.DD HH:mm";
